var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx--form-item"},[_c('cv-skeleton-text',{attrs:{"heading":"","width":"100px"}}),_c('cv-skeleton-text',{staticClass:"bx--label-description",attrs:{"width":"225px"}}),_c('cv-button-skeleton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }